import { Trans, useTranslation } from "react-i18next";
import image_01 from '../../img/TradeTerminal/Banner/image_01.jpg';
import image_02 from '../../img/TradeTerminal/Banner/image_02.jpg';
import Button from "../Button";

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="relative mt-[60px] md:mt-[90px] xl:mt-[200px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex md:flex-row flex-col-reverse">
                    <div className="xl:pr-[50px] md:pr-[25px] pb-[13px] xl:w-[calc(100%-680px)] md:w-[50%]">
                        <h1 className="pt-[30px] md:pt-0 open-sans text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            <Trans>
                                {t('terminal.banner.title')}
                            </Trans>
                        </h1>
                        <p className="open-sans sm:text-[16px] font-[700] text-[14px] text-[#0C2780] mt-[15px]">
                            {t('terminal.banner.subtitle')}
                        </p>
                        <Button className="mt-[40px] hidden md:flex" color="#15318D" text="#EFEFEF" />
                    </div>
                    <div className="xl:w-[697px] md:w-[50%] sm:w-[100%] w-[calc(100%+40px)] sm:ml-0 ml-[-20px]">
                        <img className="w-[100%] md:rounded-[20px]" src={image_01} alt='' />
                    </div>
                </div>
                <div className="flex md:flex-row flex-col-reverse xl:mt-[60px] md:mt-[40px]">
                    <div className="xl:w-[697px] md:w-[50%] hidden md:block">
                        <img className="w-[100%] rounded-[20px]" src={image_02} alt='' />
                    </div>
                    <div className="xl:pl-[50px] md:pl-[25px] md:w-[50%]">
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                            <Trans>
                                {t('terminal.banner.text')}
                            </Trans>
                        </p>
                        <Button className="mt-[40px] flex md:hidden" color="#15318D" text="#EFEFEF" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
